<template>
  <div class="contents_wrap" id="contents_wrap">
    <div class="small_title_wrap">
      <h2>{{ sendInfo.sendScnNm }} 정보</h2>
    </div>
    <div class="box_flex mgt10 mgb10">
      <button type="button" class="mid_btn mr5 f_l" @click="sampleDownload" >
        <span><span class="k-icon k-i-download"></span>등기 샘플 파일</span>
      </button>
    </div>
    <kendo-grid
        id="sendBatchGrid"
        ref="sendBatchGrid"
        class="basic_table mgt10"
        style="cursor: pointer;"
        max-height="'100'"
        :navigatable="true"
        :filterable="false"
        :scrollable="true"
        :reorderable="true"
        :columns="sendBatchSaveColumns"
        :editable="true"
        :editable-mode="'inline'"
        :editable-confirmation="'해당 발송 정보를 삭제하시겠습니까?'"
        :selectable="'multiple row'"
        :noRecords="{ template: '<div class=\'gridNoData\' style=\'text-align: center;\'>Ctrl+V 를 이용해 붙여넣기 가능합니다.</div>' }"
    >
    </kendo-grid>
  </div>
</template>

<script>
import ApiConfig from "@/api/api.config";
import $ from "jquery";
import EtnersCommonUtil from "@/common/etners.common.util";

export default {
  name: "SendBundleSaveRegi",
  props: {
    sendInfo: {
      type : Object,
      required : false,
    },
  },
  methods: {
    sampleDownload () {
      window.location = `${ApiConfig.eklDomain}/invariable/files/logistics_send_regi_excel_upload_form.xlsx`
    },
    setSendData (rows) {
      const vm = this
      let dataSource = vm.$refs.sendBatchGrid.kendoWidget().dataSource.data()

      let data = []
      let idx = 1, rowNo = dataSource.length + 1
      for (let row of rows){
        let cells = row.split('\t')
        if (EtnersCommonUtil.isEmpty(cells[0]) && EtnersCommonUtil.isEmpty(cells[1])) {
          continue
        }
        data.push({
          No: rowNo++,
          ppsScn: cells[idx+1],
          blNo: cells[idx+2],
          area: cells[idx+3],
          sendDept: cells[idx+4],
          sendNm: cells[idx+5],
          sendTel: cells[idx+6],
          sendSabun: cells[idx+7],
          sendMailAddr: cells[idx+8],
          steadYn: cells[idx+9],
          steadDept: cells[idx+10],
          receiveNm: cells[idx+11],
          receiveTel: cells[idx+12],
          receivePost: cells[idx+13],
          receiveAddr: cells[idx+14],
          receiveAddrDtl: cells[idx+15],
          deliveryScn: cells[idx+16],
          contentsScn: cells[idx+17],
          contentsScnDesc: cells[idx+18],
          regCost: cells[idx+19],
          lockerId: cells[idx+20],
          contents: cells[idx+21],
        })
      }
      dataSource = [
        ...dataSource,
        ...data
      ]
      vm.$refs.sendBatchGrid.kendoWidget().setDataSource(dataSource)
    },
  },
  data () {
    const vm = this
    const kendoGridHeaderAttributes = {
      style: 'font-weight: bold; text-align : center;'
    }
    return {
      shpcScn: '05',
      sendBatchSaveColumns: [
        {
          field: 'No',
          title: 'No.',
          width: '3%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
          sortable: false
        },
        {
          field: 'ppsScn',
          title: '용도',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'blNo',
          title: '운송장 번호',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'area',
          title: '사업장 / 거점',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'sendDept',
          title: '발신 부서',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'sendNm',
          title: '발신',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'sendTel',
          title: '전화 번호',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'sendSabun',
          title: '사원 번호',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'sendMailAddr',
          title: '이메일',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'steadYn',
          title: '대리 발송',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'steadDept',
          title: '발송인 부서',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'receiveNm',
          title: '수신',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'receiveTel',
          title: '수신 연락처',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'receivePost',
          title: '수신 우편번호',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'receiveAddr',
          title: '수신 주소',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'receiveAddrDtl',
          title: '상세 주소',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'deliveryScn',
          title: '발송 수단',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'contentsScn',
          title: '내용물',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'contentsScnDesc',
          title: '내용물 상세',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'regCost',
          title: '신고 금액',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'lockerId',
          title: '보관 위치',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'contents',
          title: '비고',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          command: [
            {
              name:'destroy',
              className: "small_btn mr10",
              template: kendo.template(`<a class="small_btn k-grid-destroy mr10" style="height:24px;"><span class="k-icon k-i-trash"></span></a>`),
              click: function (e){
                e.preventDefault()
                let tr = $(e.target).closest('tr')
                let removeItem = this.dataItem(tr)

                vm.$refs.sendBatchGrid.kendoWidget().dataSource.remove(removeItem);
              },
            }
          ],
          width: '8%',
        }
      ],
    }
  },
}
</script>

<style scoped>

</style>